export default "__VITE_ASSET__CPU1TZNO__"